import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/en-gb';

export const DatePicker = ({ value, onChange }) => {
  const handleChange = newValue => {
    if (newValue && newValue.isValid()) {
      onChange(newValue.format('YYYY/MM/DD'));
    }
  };

  // 56 days from now
  const minDate = dayjs().add(56, 'day');
  const maxDate = dayjs('2036-12-31');
  
  // Convert string value to dayjs object
  const dateValue = value ? dayjs(value, 'YYYY/MM/DD') : null;

  return (
    <LocalizationProvider adapterLocale="en-gb" dateAdapter={AdapterDayjs}>
      <MuiDatePicker
        format="YYYY/MM/DD"
        maxDate={maxDate}
        minDate={minDate}
        value={dateValue}
        onChange={handleChange}
        disablePast
        slotProps={{
          textField: {
            fullWidth: true,
            sx: {
              backgroundColor: '#161619',
              '& .MuiInput-underline:after': {
                height: '50px',
              },
              '& .Mui-focused': {
                borderRadius: 0,
                border: '2px solid #e8a0ff',
              },
              '& .MuiInput-underline.Mui-error:after': {
                transform: 'scaleX(1)',
                height: '50px',
                border: '2px solid red',
              },
              '& .MuiInputBase-adornedEnd': {
                margin: 0,
              },
              '& input, & .MuiSvgIcon-root': {
                color: 'rgba(255, 255, 255, 0.4)',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};
